import { render } from "./ItemsDetail.vue?vue&type=template&id=41451e08"
import script from "./ItemsDetail.vue?vue&type=script&lang=js"
export * from "./ItemsDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Maraki(Lika)\\Desktop\\zowitech work\\seregela_frontend_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__